import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton } from "@mui/material";
import { type Ref, useState } from "react";
import Picture from "@/components/common/Picture";
import CallToAction from "@/components/site-builder/CallToAction";
import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import TextField from "@/components/site-builder/TextField";
import { type FlexPosition } from "@/constants/content";
import type { DropColumnTextBlock } from "../types";
import CornerLabelVariant1 from "./CornerLabelVariant1";
import s from "./DropColumnVariant1.module.scss";
import RevealableBlock from "./RevealableBlock";

interface DropColumnVariant1Props {
  block: DropColumnTextBlock;
  ref: Ref<HTMLDivElement>;
  open?: boolean;
  minHeight?: number;
  buttonsAlignment: FlexPosition;
}

export default function DropColumnVariant1(props: DropColumnVariant1Props) {
  const {
    block: {
      headerImage,
      title,
      subTitle,
      strapline,
      body,
      buttons,
      revealedImage,
      callToActionButtonText,
      showDisableCTAButton,
      cornerLabelText,
      displayCornerLabel,
    },
    open = false,
    minHeight,
    ref,
    buttonsAlignment,
  } = props;
  const [isOpened, setIsOpened] = useState(open);
  const showRevealableBlock = body.text || revealedImage?.source?.path;

  const handleRevealButtonClick = () => {
    setIsOpened(!isOpened);
  };

  return (
    <>
      <div ref={ref} style={{ minHeight: minHeight }} className={s.card}>
        <Picture imageConfig={headerImage} />
        <div className={s.body}>
          {showRevealableBlock && (
            <IconButton
              onClick={handleRevealButtonClick}
              size="small"
              data-open={isOpened}
              className={s.revealButton}
            >
              <ExpandMoreIcon />
            </IconButton>
          )}
          {displayCornerLabel && cornerLabelText.text && (
            <CornerLabelVariant1
              text={cornerLabelText.text}
              className={s.cornerLabel}
            />
          )}
          <TextField field={title} type="header-h3" className={s.title} />
          <TextField field={subTitle} type="header-h4" />
          <TextField field={strapline} type="text-large" />

          {buttons.length > 0 && (
            <div className={s.buttonGroupWrapper}>
              <CallToActionGroup position={buttonsAlignment}>
                {buttons.map((buttonConfig, index) => (
                  <CallToAction
                    key={index}
                    config={buttonConfig}
                    disabled={showDisableCTAButton}
                  >
                    {showDisableCTAButton && callToActionButtonText.text}
                  </CallToAction>
                ))}
              </CallToActionGroup>
            </div>
          )}
        </div>
      </div>

      {showRevealableBlock && (
        <RevealableBlock text={body} image={revealedImage} open={isOpened} />
      )}
    </>
  );
}
